import { MetaData_DBPointer, tsValidateArray, tsValidateDBPointer, tsValidateString, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { orderGroupOperations } from './types.js';
import { knowledgeManagerDBGroup, Validator_TagGroup, Metadata_TagGroup } from '@app/hcs-shared';
import { ActionSubTypes_Order, DBDef_Action } from '../action/index.js';
const Validator_ModifiableProps = {
    name: tsValidateString(),
    label: tsValidateString(-1, false),
    operation: tsValidateValue([...orderGroupOperations]),
    items: tsValidateArray(tsValidateDBPointer([DBDef_Action])),
    subType: tsValidateValue([...ActionSubTypes_Order]),
    tagGroups: tsValidateArray(Validator_TagGroup),
};
const Validator_GeneratedProps = {
    __orderIds: tsValidateArray(tsValidateUniqueId),
    _tagIds: tsValidateArray(tsValidateUniqueId)
};
const dependencies = {
    __orderIds: {
        dbKey: DBDef_Action.dbKey,
        fieldType: 'string[]',
    },
    _tagIds: {
        dbKey: 'tags',
        fieldType: 'string[]'
    }
};
const metadata = {
    name: {
        valueType: 'string',
        optional: false,
        description: 'Name of the group',
    },
    label: {
        valueType: 'string',
        optional: true,
        description: 'Label of the group',
    },
    operation: {
        valueType: 'string',
        optional: false,
        description: 'Operation of the group'
    },
    subType: {
        valueType: 'string',
        optional: false,
        description: 'SubType of the group',
    },
    items: {
        valueType: 'object[]',
        optional: false,
        description: 'A list of items that comprise the group',
        metadata: MetaData_DBPointer,
    },
    tagGroups: {
        valueType: 'object[]',
        optional: false,
        description: 'A list of tags',
        metadata: Metadata_TagGroup
    },
    __orderIds: {
        valueType: 'string[]',
        optional: false,
        description: 'An indexing array for DB_Action',
        metadata: {
            valueType: 'string',
            optional: false,
            description: 'ID of a DB_Action',
        }
    },
    _tagIds: {
        valueType: 'string[]',
        optional: false,
        description: 'Order group tags',
        metadata: {
            valueType: 'string',
            optional: false,
            description: 'ID of a tag',
        }
    }
};
export const DBDef_OrderGroup = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.3', '1.0.2', '1.0.1', '1.0.0'],
    dbKey: 'order-group',
    entityName: 'Order Group',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'order-group'
    },
    backend: {
        name: 'order-group'
    },
    generatedProps: ['__orderIds', '_tagIds'],
    dependencies,
    metadata,
};
//# sourceMappingURL=db-def.js.map